import { useRef } from 'react';
import * as React from 'react';
import styled from 'styled-components';
import View from '@sdk/components/primitives/View';
import HorizontalSeparator from '@sdk/components/ui/HorizontalSeparator';
import Column from '@sdk/components/ui/spacing/Column';
import Padding from '@sdk/components/ui/spacing/Padding';
import { SpacingType } from '@sdk/components/ui/spacing/SpacingStyle';

type ContentContainerProps = {
  isActive: boolean;
  contentHeight: number;
};

const ContentContainer = styled(Column)<ContentContainerProps>`
  opacity: ${({ isActive }): number => (isActive ? 1 : 0)};
  visibility: ${({ isActive }): string => (isActive ? 'visible' : 'hidden')};
  max-height: ${({ isActive, contentHeight }): number => (isActive ? contentHeight : 0)}px;
  transition:
    max-height 0.2s ease,
    opacity 0.2s ease;
  flex-grow: 1;
  outline: none;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    /* IE10+ CSS styles go here */
    ${({ isActive }): string => !isActive && 'display: none'}
  }
`;

type Props = {
  isActive: boolean;
  withSeparator?: boolean;
  placeHeaderAsFooter?: boolean;
  headerItem: JSX.Element;
  contentItem: JSX.Element;
} & SpacingType;

const CollapsibleSettingsSection: React.FC<React.PropsWithChildren<Props>> = ({
  isActive,
  headerItem,
  contentItem,
  withSeparator,
  placeHeaderAsFooter = false,
  ...props
}) => {
  const content = useRef(null);

  return (
    <Column {...props}>
      {!placeHeaderAsFooter && <View>{headerItem}</View>}

      {withSeparator && (
        <Padding top={20} bottom={20}>
          <HorizontalSeparator />
        </Padding>
      )}

      <ContentContainer
        ref={content}
        isActive={isActive}
        contentHeight={content.current?.scrollHeight}>
        <Column>{contentItem}</Column>
      </ContentContainer>

      {placeHeaderAsFooter && <View>{headerItem}</View>}
    </Column>
  );
};

export default CollapsibleSettingsSection;
